module.exports = __webpack_public_path__ + "assets/images/walk_support_r.367eef8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/walk_support_r.png
// module id = 775
// module chunks = 1